import { Box, styled } from '../../base';

export const MobileLoginWrapper = styled(Box)(({ theme }) => ({
    minHeight: '100vh',
    background: theme.palette.background.default, // Or a subtle purple theme.palette.primary.light?
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between', // Changed to push bottom logo down
    padding: theme.spacing(3),
    width: '100%', // Ensure full width on mobile
    boxSizing: 'border-box', // Include padding in width calculation
    position: 'relative', // Added for positioning context
}));

export const TopLogoWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(4), // Add space below logo
    paddingTop: theme.spacing(4), // Add some padding above logo
    svg: {
        maxWidth: '150px', // Adjust logo size for mobile
        height: 'auto',
    },
}));

export const ContentWrapper = styled(Box)({
    width: '100%',
    maxWidth: '500px', // Limit content width for readability
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1, // Allow content to take up space
    justifyContent: 'center', // Center content vertically in the middle
});

// Renamed the original LogoWrapper to TopLogoWrapper above
// Added BottomLogoWrapper
export const BottomLogoWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4, 0), // Padding top/bottom
    svg: {
        maxWidth: '100px', // Make bottom logo smaller
        height: 'auto',
        opacity: 0.7, // Slightly faded
    },
}));
